enum ResearchTopicTemplate {
  V1 = "v1",
  V2 = "v2"
}

export { ResearchTopicTemplate };
